import { createStore } from "vuex";
import axios from "axios";
import moment from "moment";

const User_List_URL = process.env.VUE_APP_Users_List;
const User_Detail_URL = process.env.VUE_APP_User_Detail;
// const User_Expire_Update_URL = process.env.VUE_APP_User_Expire_Update;
const Influencer_List_URL = process.env.VUE_APP_Influencers_List;
const Summary_URL = process.env.VUE_APP_SUMMARY;
const Payment_URL = process.env.VUE_APP_User_Payment;

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
    members: [],
    users: [],
    user: {},
    user_members: [],
    summary: {},
    influencers: [],
    payments: [],
    isLoading: false,
    isLoading_User: false,
    isLoading_Influencer: false,
    isLoading_Summary: false,
    isLoading_Payment: false,
    memo: [],
  },
  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setLoading_User(state, isLoading_User) {
      state.isLoading_User = isLoading_User;
    },
    setLoading_Influencer(state, isLoading_Influencer) {
      state.isLoading_Influencer = isLoading_Influencer;
    },
    setLoading_Summary(state, isLoading_Summary) {
      state.isLoading_Summary = isLoading_Summary;
    },
    setLoading_Payment(state, isLoading_Payment) {
      state.isLoading_Payment = isLoading_Payment;
    },
    setUsers(state, users) {
      state.users = users;
      state.isLoading = false;
    },
    setUser(state, user) {
      state.user = user;
      state.isLoading_User = false;
    },
    setUserMembers(state, user_members) {
        state.user_members = user_members;
        // state.isLoading_User = false;
    },
    setInfluencers(state, influencers) {
      state.influencers = influencers;
      state.isLoading_Influencer = false;
    },
    setSummary(state, summary) {
      state.summary = summary;
      state.isLoading_Summary = false;
    },
    setPayments(state, payments) {
      state.payments = payments;
      state.isLoading_Payment = false;
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    getUsers({ commit }, payload) {
      commit("setLoading", true);
      axios
        .post(
          User_List_URL,
          {},
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          if (
            !response?.data.status ||
            response?.data.status !== "success" ||
            !response?.data?.users
          ) {
            alert("Error on getUsers");
            return;
          }
          let users = response.data.users;
          users = users.map((user) => {
            let user_remaining_day = moment().isValid(user.expire_date) ? moment(user.expire_date).diff(moment(), 'days') : 0;
            const ref_user = users.find((u) => u.username === user.ref_username) || {};
            user['ref_line_display'] = ref_user['line_display'];
            user['ref_user_data'] = ref_user['line_display'];
            user['remaining_day'] = user_remaining_day > 0 ? user_remaining_day : 0;
            // user['remaining_day'] = moment.isva moment(user.expire_date).diff(moment(), 'days');
            return user;
          });
          console.log({ users });
          // state.users = users;
          commit("setUsers", users);
          if (payload) {
            // payload();
            const user =
              users.find((user) => user.username === payload) || false;
            commit("setUser", user);
          }
          commit("setLoading", false);
        })
        .catch((error) => {
          console.log({ error });
          alert("Error on getUsers");
        });
    },
    getUser({ commit }, payload) {
      commit("setUser", {});

      commit("setLoading_User", true);
      axios
        .post(
            User_Detail_URL,
          {
            username: payload,
          },
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          if (
            !response?.data.status ||
            response?.data.status !== "success" ||
            !response?.data?.user
          ) {
            alert("Error on get User Detail");
            return;
          }
          let user = response?.data?.user ?? false;
          if(user){
            let user_remaining_day = moment().isValid(user.expire_date) ? moment(user.expire_date).diff(moment(), 'days') : 0;
            user['remaining_day'] = user_remaining_day > 0 ? user_remaining_day : 0;
          }
            let user_members = response?.data?.member ?? [];
            user_members = user_members.map((u) => {
                let user_remaining_day = moment().isValid(u.expire_date) ? moment(u.expire_date).diff(moment(), 'days') : 0;
                u['remaining_day'] = user_remaining_day > 0 ? user_remaining_day : 0;
                return u;
            });
          console.log({ user,user_members });
          commit("setUser", user);
          commit("setUserMembers", user_members);
          // }
          commit("setLoading_User", false);
        })
        .catch((error) => {
          console.log({ error });
          alert("Error on getUser");
        });
    },
    getInfluencers({ commit }, payload) {
      commit("setLoading_Influencer", true);
      axios
        .post(
          Influencer_List_URL,
          {},
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          if (
            !response?.data.status ||
            response?.data.status !== "success" ||
            !response?.data?.influencers
          ) {
            alert("Error on getInfluencers");
            return;
          }
          let users = response?.data?.influencers;
          
          console.log({ users });
          // state.users = users;
          // commit('setUsers', users);
          // if(payload){
          // payload();
          let influencers = users.map((user) => {
            let user_remaining_day = moment().isValid(user.expire_date) ? moment(user.expire_date).diff(moment(), 'days') : 0;
            user['remaining_day'] = user_remaining_day > 0 ? user_remaining_day : 0;
            return user
          });
          if (payload) {
            influencers = users.filter((user) => user.ref_username === payload);
          }
          commit("setInfluencers", influencers);
          // }
          commit("setLoading_Influencer", false);
        })
        .catch((error) => {
          console.log({ error });
          alert("Error on getInfluencers");
        });
    },
    getSummary({ commit }) {
      commit("setLoading_Summary", true);
      axios
        .post(
          Summary_URL,
          {},
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          if (!response?.data.status || response?.data.status !== "success") {
            alert("Error on getSummary");
            return;
          }
          commit("setSummary", {
            total_users: response?.data?.total_users ?? 0,
            active_users: response?.data?.active_users ?? 0,
            expired_users: response?.data?.expired_users ?? 0,
          });
          commit("setLoading_Summary", false);
        })
        .catch((error) => {
          console.log({ error });
          alert("Error on getSummary");
        });
    },
    getPayments({ commit }, payload) {
      commit("setLoading_Payment", true);
      axios
        .post(
          Payment_URL,
          {
            username: payload,
          },
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          if (
            !response?.data.status ||
            response?.data.status !== "success" ||
            !response?.data?.user_payments
          ) {
            // alert("Error on getPayments");
            // return;
          }
          const payments = response?.data?.user_payments ?? [];
          console.log({ payments });
          // state.users = users;
          // commit('setUsers', users);
          // if(payload){
          // payload();
          let filtered_payments = payments;
          commit("setPayments", filtered_payments);
          // }
          commit("setLoading_Payment", false);
        })
        .catch((error) => {
          console.log({ error });
          alert("Error on getPayments");
        });
    },
    // updateUserExpireDate({ commit }, payload) {
    //     commit("setLoading_User", true);
    //     axios
    //         .post(
    //         Update_User_Expire_Date_URL,
    //         {
    //             username: payload.username,
    //             expire_date: payload.expire_date,
    //         },
    //         { headers: { "Content-Type": "application/json" } }
    //         )
    //         .then((response) => {
    //         if (
    //             !response?.data.status ||
    //             response?.data.status !== "success" ||
    //             !response?.data?.user
    //         ) {
    //             alert("Error on Update User Expire Date");
    //             return;
    //         }
    //         let user = response?.data?.user ?? false;
    //         if(user){
    //             let user_remaining_day = moment().isValid(user.expire_date) ? moment(user.expire_date).diff(moment(), 'days') : 0;
    //             user['remaining_day'] = user_remaining_day > 0 ? user_remaining_day : 0;
    //         }
    //         const user_members = response?.data?.member ?? [];
    //         console.log({ user });
    //         commit("setUser", user);
    //     })
    // },
  },
  getters: {},
});
